import type { IAlert } from '@store/types';
import { AlertLevel } from '@store/types';
import React, { useEffect } from 'react';

interface IProps extends IAlert {
  onClose: (id: string) => void;
  timeout?: number;
}

export default function Alert({ onClose, timeout = 3000, ...alert }: IProps) {
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (timeout !== undefined && !isNaN(timeout)) {
      timer = setTimeout(() => onClose(alert.id), timeout);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [alert.id, onClose, timeout]);

  return (
    <div
      className={`w-full flex justify-between gap-x-4 p-1 rounded-md text-xs ${
        alert.level === AlertLevel.Error ? 'text-white bg-red-600' : ''
      } ${alert.level === AlertLevel.Warning ? 'text-white bg-yellow-600' : ''} ${
        alert.level === AlertLevel.Success ? 'text-white bg-green-600' : ''
      } ${alert.level === AlertLevel.Information ? 'text-white bg-blue-600' : ''}`}
      role="alert">
      <div className="p-2 font-medium leading-normal">{alert.message}</div>
      <div className="flex items-start justify-center">
        <button className="w-6 h-6 cursor-pointer" role="button" onClick={() => onClose(alert.id)}>
          <span className="icon">
            <i className="fa-solid fa-times fa-lg" />
          </span>
        </button>
      </div>
    </div>
  );
}
